import Products from "./Products";

// The search page is the Products page with a search heading. It reads the same search text
// from the navbar (SearchContext) and queries the database, with sorting and pagination.
export default function SearchResults() {
  return <Products title="Search results" />;
}